import { render, staticRenderFns } from "./PreguntasFrecuentes.vue?vue&type=template&id=7510d7e0"
import script from "./PreguntasFrecuentes.vue?vue&type=script&lang=ts"
export * from "./PreguntasFrecuentes.vue?vue&type=script&lang=ts"
import style0 from "./PreguntasFrecuentes.vue?vue&type=style&index=0&id=7510d7e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports